import React from 'react'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'
import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string/index.js'
import getSearchRouterSelect from 'modules/router/selectors/get-search/index.js'
import openAppSignInModalAction from 'modules/modal/actions/open-app-sign-in/index.js'
import { runAfterDelayPromisifiedPerformanceUtil } from '@gymaholic/packages'

/**
 * Container component that opens the login modal when ?openLogin=true is in the URL
 * Only opens if user is not already logged in
 * @returns {null}
 * @constructor
 */
export function OpenLoginModal () {
  const dispatch = useDispatch()
  const trainingUser = useSelector(getCurrentTrainingUserSelect)
  const search = useSelector(getSearchRouterSelect)

  const handleLoginModal = async () => {
    const queryParams = getQueryParamsFromStringObjectUtil(search)

    if (!queryParams?.openLogin) {
      return
    }

    if (trainingUser) {
      return
    }

    await runAfterDelayPromisifiedPerformanceUtil()
    dispatch(openAppSignInModalAction())
  }

  React.useEffect(() => {
    handleLoginModal()
  }, [search])

  return null
}
